export default "__VITE_ASSET__Di_sIBgI__"